export type Category = {
  id: string;
  label: string;
  icon: string;
};

export type NavMenuConfiguration = {
  category: Category;
};

const navMenuConfigurations: NavMenuConfiguration[] = [
  {
    category: {
      id: "join-work-grow",
      label: "Join, Work, Grow",
      icon: "ri-open-arm-line ri-xl",
    },
  },
  {
    category: {
      id: "employment",
      label: "Employment",
      icon: "ri-folder-user-line ri-xl",
    },
  },
  {
    category: {
      id: "leadership",
      label: "Leadership",
      icon: "ri-team-line ri-xl",
    },
  },
];

export function getCategory(categoryId: string): Category {
  const navMenuConfiguration: NavMenuConfiguration | undefined =
    navMenuConfigurations.find((config) => config.category.id === categoryId);
  if (navMenuConfiguration) return navMenuConfiguration.category;
  console.error(`Category: ${categoryId} Does Not Exist`);
}
